import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Sider from 'antd/es/layout/Sider';
import React, { useState, useEffect } from 'react';
import { Button, Menu } from 'antd';
import { AiOutlineDashboard } from 'react-icons/ai';
import { IoIosPeople } from 'react-icons/io';
import { SiBookstack } from 'react-icons/si';
import { CiBank } from 'react-icons/ci';
import { HiShoppingCart } from 'react-icons/hi';
import { PiDotsNineFill } from 'react-icons/pi';
import { BsListTask } from 'react-icons/bs';
import { FaFileInvoiceDollar, FaUserTie } from 'react-icons/fa';
import { BsGraphUpArrow } from 'react-icons/bs';
import { LuCalculator } from 'react-icons/lu';
import { MdMoveToInbox } from 'react-icons/md';
import { LuListTodo } from 'react-icons/lu';
import './Sider.css';
import { Link } from 'react-router-dom';
import admin from '../../images/admin.png';
import { CgProfile } from 'react-icons/cg';
import AdvocateLogo from '../../assets/Advocate.svg';

const SiderComponent = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
  };

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      }
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const menuItems = [
    {
      key: '1',
      icon: <AiOutlineDashboard />,
      label: <Link to="/">Dashboard</Link>,
    },
    {
      key: '2',
      icon: <IoIosPeople />,
      label: (
        <a
          href="https://hr.defconinnovations.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          HR Management
        </a>
      ),
    },
    {
      key: '3',
      icon: <FaUserTie />, // or any other appropriate icon
      label: <Link to="/clients">Clients</Link>,
    },
    {
      key: '4',
      icon: <PiDotsNineFill />,
      label: <Link to="/cases">Cases</Link>,
    },
    {
      key: '5',
      icon: <SiBookstack />,
      label: <Link to="/case-study">Case Study</Link>,
    },
    {
      key: '6',
      icon: <BsListTask />,
      label: (
        <a
          href="https://taskpro.defconinnovations.com/kanbanboard"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tasks
        </a>
      ),
    },
    {
      key: '7',
      icon: <CiBank />,
      label: (
        <a
          href="http://accounting.defconinnovations.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Banking
        </a>
      ),
    },
    {
      key: '8',
      icon: <HiShoppingCart />,
      label: (
        <a
          href="http://proerp.defconinnovations.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Products And Services
        </a>
      ),
    },
    {
      key: '9',
      icon: <FaFileInvoiceDollar />,
      label: (
        <a
          href="http://admin.defconinnovations.com/accounting/invoiceslist/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Invoice
        </a>
      ),
    },
    {
      key: '10',
      icon: <LuCalculator />,
      label: (
        <a
          href="http://accounting.defconinnovations.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Expenses
        </a>
      ),
    },
    {
      key: '11',
      icon: <BsGraphUpArrow />,
      label: (
        <a
          href="http://admin.defconinnovations.com/accounting/reportingdashboard/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Reports
        </a>
      ),
    },
    {
      key: '12',
      icon: <MdMoveToInbox />,
      label: <Link to="/messages">Message</Link>,
    },
    {
      key: '13',
      icon: <LuListTodo />,
      label: (
        <a
          href="https://taskpro.defconinnovations.com/kanbanboard"
          target="_blank"
          rel="noopener noreferrer"
        >
          To-Do List
        </a>
      ),
    },
  ];

  return (
    <Sider
      className="sider-component"
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={250}
      style={siderStyle}
    >
      <div
        className="sider-header"
        onClick={() => setCollapsed(!collapsed)}
        style={{ cursor: 'pointer' }}
      >
        <img
          src={AdvocateLogo}
          alt="Advocate Logo"
          className="sider-logo"
          style={{ height: '50px', transition: 'all 0.3s ease' }}
        />
        {!collapsed && (
          <span
            className="sider-title"
            style={{ marginLeft: '12px', fontSize: '20px', fontWeight: 'bold' }}
          >
            AdvocatePro
          </span>
        )}
      </div>

      {/* <div className="admin-info">
        <img className="admin-avatar" src={admin} alt="admin icon" />
        {!collapsed && (
          <div className="admin-details">
            <h5>Administrator</h5>
            <p>● Online</p>
          </div>
        )}
      </div> */}

      {/* {!collapsed && (
        <div className="navigation-header">
          <h3>Navigation</h3>
        </div>
      )} */}

      <Menu
        className="sider-menu"
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['1']}
        items={menuItems}
      />
    </Sider>
  );
};

export default SiderComponent;
